<template>
  <div
    id="myChart1"
    :style="{ width: '90%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
export default {
  props: ["chartsData"],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },
  methods: {
    drawLine() {
      if (document.getElementById("myChart1") == null) {
        return;
      }
      this.$echarts.dispose(document.getElementById("myChart1"));
      let myChart = this.$echarts.init(document.getElementById("myChart1"));
      myChart.setOption({}, true);
      let salvProValue = this.chartsData.data;
      let salvProMax = []; //背景按最大值
      for (let i = 0; i < salvProValue.length; i++) {
        salvProMax.push(salvProValue[0]);
      }
      let option = {
        grid: {
          left: "2%",
          right: "2%",
          bottom: "2%",
          top: "2%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          formatter: function (params) {
            return params[0].name + " : " + params[0].value;
          },
        },
        xAxis: {
          show: false,
          type: "value",
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLabel: {
              show: true,
              color: "#CBCBCB",
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: this.chartsData.yData,
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            show: true,
            axisLabel: {
              color: "#CBCBCB",
              fontSize: "12",
            },
            data: salvProValue,
          },
        ],
        series: [
          {
            name: "值",
            type: "bar",
            zlevel: 1,
            itemStyle: {
              borderRadius: 30,
              color: {
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(57,89,255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgba(46,200,207,1)",
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
            barWidth: 20,
            data: salvProValue,
          },
          {
            name: "背景",
            type: "bar",
            barWidth: 20,
            barGap: "-100%",
            data: salvProMax,
            itemStyle: {
              color: "#eee",
              borderRadius: 30,
            },
          },
        ],
      };
      myChart.setOption(option, true);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {},
};
</script>

<style>
</style>